package com.example.mystybag.communication.defines

/**
 * Целева директория на сървъра за качване на файл.
 * Стойността се изпраща като form field при multipart upload.
 */
enum class FileUploadTarget(val serverPath: String) {
    PROFILE("PROFILE"),
    MERCHANTS("MERCHANTS"),
    MERCHANT_LOCATIONS("MERCHANT_LOCATIONS"),
    MERCHANT_LOCATION_MENU_PHOTOS("MERCHANT_LOCATION_MENU_PHOTOS");
}
